export const isLogin = () => {
  return true;
};

export const getToken = () => {
  return sessionStorage.getItem('token') || localStorage.getItem("token");
}

export const isLoggedIn = (token = null) => {
  if (!token) {
    token = getToken();
  }
  if (token) {
    try {
      const base64Url = token.split('.')[1];
      if (!base64Url) return false;
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const tokenData = JSON.parse(atob(base64));
      if (tokenExpired(tokenData.exp)) {
        return {
          userId: tokenData.result.userid,
          countryId: tokenData.result.country,
          email: tokenData.result.email,
          firstName: tokenData.result.firstname,
          lastName: tokenData.result.lastname,
          roleId: tokenData.result.roleid,
        };
      } else {
        return false;
      }
    } catch (e) {
      console.log('[Auth] Invalid token format', e.message);
      // sessionStorage.removeItem('token');
      // localStorage.removeItem('token');
      return false;
    }
  } else {
    return false;
  }
};

export const tokenExpired = (exp) => {
  let today = new Date().getTime();
  today = (today - (today % 1000)) / 1000;
  return today < exp;
}

export const getAuth = () => {
  return function (dispatch) {
    // console.log(dispatch);
  }
}
